import { hot } from 'react-hot-loader/root';

import React, { StrictMode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import PageHeader from "./layout/PageHeader";
import PageContent from "./layout/PageContent";
import ExceptionPage from "./exception/ExceptionPage";
import SideNav from "./layout/SideNav";
import Beads from "./layout/Beads";
import { generateGuid } from "../util/guid";
import { Dimmer } from "semantic-ui-react";
import Loader from "./common/Loader";
import ConfirmModal from "./common/ConfirmModal";

import { getRoutes } from "../components/Navigation";

class App extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			showStatusPopup: false,
			previousLocation: ''

		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.location !== this.props.location) {
			this.setState({ previousLocation: prevProps.location });
		}
	}

	onClickStatusButton = () => {
		this.setState({
			showStatusPopup: true
		});
		window.parent.scrollTo(0, 10);
	};

	confirmStatusPopup = () => {
		this.setState({
			showStatusPopup: false
		});
	};

	render() {
		const { showHeader, showTopNav, showSideNav, showBeads, loading, pageHeaderTitle, pageHeaderSubtitle, exception, topNavTabSettings, scope, match, transactionId, customModal, isReadOnly } = this.props;
		return (
			// <StrictMode>
			<div>
				<ExceptionPage exception={exception}>
					<Dimmer active={loading} page><Loader /></Dimmer>
					{showHeader ?
						<PageHeader
							showTopNav={showTopNav}
							title={pageHeaderTitle}
							intro={pageHeaderSubtitle}
							topNavTabSettings={topNavTabSettings}
							scope={scope}
							transactionId={transactionId}
							isReadOnly={isReadOnly} />
						: null}
					<PageContent id="modal-holder_pageconten" loading={loading}>
						{showSideNav ? <SideNav key={generateGuid()} transactionId={transactionId} /> : null}
						{showBeads ? <Beads onClickStatusButton={this.onClickStatusButton} confirmStatusPopup={this.confirmStatusPopup} showStatusPopup={this.state.showStatusPopup} /> : null}
						{getRoutes(match)}
					</PageContent>
					<div id="modal-holder"></div>
				</ExceptionPage>
				<ConfirmModal
					hookToTop
					isOpen={customModal.isOpen}
					title={customModal.title}
					mainText={customModal.message}
					confirmAction={customModal.onConfirm}
					confirmText="Ga verder"
					cancelText="Terug"
					cancelAction={customModal.onCancel}
					showUnsavedChangesMessage={customModal.handleUnsavedChanges} />
			</div>
			// </StrictMode>
		);
	}
}

App.propTypes = {
	loading: PropTypes.bool.isRequired,
	showHeader: PropTypes.bool.isRequired,
	showTopNav: PropTypes.bool.isRequired,
	topNavTabSettings: PropTypes.object.isRequired,
	transactionId: PropTypes.string,
	showSideNav: PropTypes.bool.isRequired,
	showBeads: PropTypes.bool.isRequired,
	pageHeaderSubtitle: PropTypes.string,
	pageHeaderTitle: PropTypes.string.isRequired,
	exception: PropTypes.object,
	scope: PropTypes.string.isRequired,
	match: PropTypes.object.isRequired,
	customModal: PropTypes.object.isRequired,
	isReadOnly: PropTypes.bool,
	location: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	return {
		loading: state.ajaxCounter > 0,
		showHeader: state.layout.showHeader,
		showTopNav: state.layout.showTopNav,
		topNavTabSettings: state.layout.topNavTabSettings,
		transactionId: state.session.activeTransactionId,
		showSideNav: state.layout.showSideNav,
		showBeads: state.layout.showBeads,
		pageHeaderTitle: state.layout.pageHeaderTitle,
		pageHeaderSubtitle: state.layout.pageHeaderSubtitle,
		exception: state.exception,
		scope: state.layout.scope,
		validatieStatussen: state.validatieStatussen,
		customModal: state.customModal,
		isReadOnly: state.session.readOnly
	};
}

export default hot(connect(mapStateToProps)(App));
